import { render, staticRenderFns } from "./AgeGroupTable.vue?vue&type=template&id=5263e24c&scoped=true"
import script from "./AgeGroupTable.vue?vue&type=script&lang=js"
export * from "./AgeGroupTable.vue?vue&type=script&lang=js"
import style0 from "./AgeGroupTable.vue?vue&type=style&index=0&id=5263e24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263e24c",
  null
  
)

export default component.exports